module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/wheel-62556382fe6eff3b.jpg"+" 536w",
        images: [{path: __webpack_public_path__ + "assets/images/wheel-62556382fe6eff3b.jpg",width: 536,height: 560}],
        src: __webpack_public_path__ + "assets/images/wheel-62556382fe6eff3b.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/wheel-62556382fe6eff3b.jpg"},
        
        width: 536,
        height: 560
      }